import { render, staticRenderFns } from "./TensionItem.vue?vue&type=template&id=1579b787&"
import script from "./TensionItem.vue?vue&type=script&lang=js&"
export * from "./TensionItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports